
import u from "umbrellajs"

// No memoize since it might be called too early
const getDataContainerElement = () => {
  return u("#app-data-container")
}
const getHtmlElement = () => {
  return u("html")
}
// Purpose: get data from body/html

const Retriver = {
  get(name: string) {
    return getDataContainerElement().data(name)
  },
  hasClass(name: string) {
    return getHtmlElement().hasClass(name)
  },
}

export default Retriver
